import React from 'react'

export default function IcoGrip( props ) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      { ...props }
    >
      <circle
        cx="9"
        cy="6"
        r="1.5"
      />
      <circle
        cx="15"
        cy="6"
        r="1.5"
      />
      <circle
        cx="9"
        cy="12"
        r="1.5"
      />
      <circle
        cx="15"
        cy="12"
        r="1.5"
      />
      <circle
        cx="9"
        cy="18"
        r="1.5"
      />
      <circle
        cx="15"
        cy="18"
        r="1.5"
      />
    </svg>
  )
}
